<template lang="pug">
.cart-item.gift-card-item
  .summary__line
    .summary__prod.summary__prod--left
      p {{ item.attributes.product.title }}
      p.summary__time.hidden
      p.summary_time-hide
      a.summary__edit(href='#' @click.prevent="itemEdit($event)") Edit
      a.summary_delete-hide.summary__edit(href='#' @click.prevent="itemDelete($event)") DELETE
    .summary__prod
      p -
    .summary__prod
      p.summary__price-sp.nowrap {{ item.attributes.product.price | currency }}
      p.summary__subtotal-price-hide.nowrap {{ (item.total * 1) + (item.attributes.product.tax_amount * item.payload.count) | currency }}
      .summary__calc
        button.minus-count.summary__minus(:class="{ disabled: item.payload.count <= 1 }" @click="setCount(item.payload.count - 1)")
        p.nowrap {{ item.payload.count }}
        button.plus-count.summary__plus(@click="setCount(item.payload.count + 1)")
    .summary__prod.summary__price
      p.nowrap {{ item.attributes.product.price | currency }}
    .summary__prod
      p.nowrap {{ item.attributes.product.price * item.payload.count | currency }}
    .summary__prod
      p.nowrap {{ item.attributes.product.tax * item.payload.count | currency }}
    .summary__prod.summary__prod--right.summary__prod--last
      p.nowrap {{ (Number(item.attributes.product.price) + Number(item.attributes.product.tax)) * item.payload.count | currency }}
      button.summary__remove-product(@click.prevent="itemDelete($event)")
</template>

<script>
const EventBus = window.VueEventBus
import PageMixins from '../../components/_mixins/pages'
import CartMixins from '../../components/_mixins/location-checkout'
import DatesMixin from '../../components/_mixins/dates'
import GiftCardMixin from '../../components/_mixins/giftcard'

export default {
  name: 'gift-cards-cart-item',
  settings: 'page.cart',
  translations: 'page.cart',
  mixins: [
    PageMixins,
    CartMixins,
    DatesMixin,
    GiftCardMixin
  ],

  props: {
    item: {},
    items: {},
    groupedItems: {},
    cartView: {},
    showItemRates: {
      default: false
    },
  },

  methods: {
    itemDelete($event) {
      const item = this.item
      this.cartView.cartItemButtonClicked({
        $event,
        actionName: 'delete',
        id: this.item.id,
        item,
        cartItems: this.currentCartItems,
        button: {}
      })
      // this.removeCartItem(item)
      EventBus.$emit('cart-item-deleted', item, this, this.$parent)
      EventBus.$emit('cart-item-deleted-' + item.type, item, this, this.$parent)
    },

    itemEdit($event) {
      const item = this.item
      this.cartView.cartItemButtonClicked({
        $event,
        item,
        actionName: 'edit',
        id: this.item.id,
        cartItems: this.currentCartItems,
        button: {}
      })
      EventBus.$emit('cart-item-edit', item, this, this.$parent)
      EventBus.$emit('cart-item-edit-' + item.type, item, this, this.$parent)
      this.$router.push({ name: 'racewaybooking.gift-card', query: { item: item.id } })
    },

    async setCount(count) {
      EventBus.$emit('cart.validating', true)
      await this.setCartItemCount({ id: this.item.id, count })
      await EventBus.$$emitAsync('cart.validate')
      EventBus.$emit('cart.validating', false)
    },
  }
}
</script>
